/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { Loader } from '@uswitch/comms-ui.loader'
import { UswErrorOutline } from '@uswitch/spark-icons/usw'
import React from 'react'

import Underlay from '~/components/underlay'

import * as st from './address-dropdown-style'

const AddressDropdownWrapper = ({ children, className, addressUnderlay }) => {
  return (
    <>
      <div sx={st.addressDropdownPosition} className={className}>
        <div sx={st.addressDropdownContainer} data-postcode-form-target='addressBox' className='element-hidden'>
          {children}
        </div>
      </div>

      <div
        data-postcode-form-target='addressesUnderlay'
        className='element-hidden'
        sx={st.underlayContainer(addressUnderlay)}
      >
        {addressUnderlay && <Underlay action='closeAddressDropdown' criticalJs />}
      </div>
    </>
  )
}

export const AddressDropdown = ({ addressUnderlay = false }) => {
  return (
    <AddressDropdownWrapper className='element-hidden' addressUnderlay={addressUnderlay}>
      {/* loading addresses */}
      <ul sx={st.addressesTarget} data-postcode-form-target='addressesTarget'>
        <li sx={st.addressList} data-postcode-form-target='error' className='element-hidden'>
          <ul sx={st.noPadding}>
            <li sx={st.dropdownListItem}>
              <span sx={st.addressSummary}>Please enter your postcode e.g. SE1 2LH</span>
            </li>
          </ul>
        </li>

        <li sx={st.addressList} data-postcode-form-target='loading' className='element-hidden'>
          <ul sx={st.noPadding}>
            <li sx={st.dropdownListItem}>
              <span sx={st.addressSummary}>Looking for addresses...</span>
            </li>
            <li sx={st.dropdownListItem}>
              <Loader loading={true} customCSS={st.loader}></Loader>
            </li>
          </ul>
        </li>

        {/* there are results for this postcode */}
        <li
          data-postcode-form-target='addresses'
          data-cypress-id='address-list'
          name='addresses'
          id='addresses'
          className='element-hidden'
          sx={st.addressesListWrapper}
        >
          <div
            className='dropdown-loading'
            sx={st.addressSelectedLoading}
            data-postcode-form-target='addressSelectedLoading'
          >
            <Loader loading={true} customCSS={st.addressClickLoader}></Loader>
          </div>
          <ul sx={st.addressesList}></ul>
        </li>

        {/* no results */}
        <li sx={st.addressList} data-postcode-form-target='noResultsError' className='element-hidden'>
          <ul sx={st.noPadding}>
            <li sx={st.dropdownListItem}>
              <p sx={st.errorMessage}>
                <UswErrorOutline size='21' strokeWidth='1px' sx={st.errorIcon} />
                <b sx={st.errorMessageTextBold}>Sorry, we couldn't find any addresses.</b>
                <br />
                <br />
                Check your postcode and try again.
              </p>
            </li>
          </ul>
        </li>
      </ul>
      {/* The following is used as a template within a non react js file. Don't remove */}
      <div sx={{ display: 'none' }}>
        <ul data-postcode-form-target='hiddenListElement'>
          <li className='hidden-list-element' data-nerd-capture data-address-index='ELEMENT_INDEX'>
            <button
              data-action='click->postcode-form#clickAddress'
              type='button'
              className='hidden-list-element-text'
              sx={st.addressSummary}
            >
              ELEMENT_TEXT
            </button>
          </li>
        </ul>
      </div>
    </AddressDropdownWrapper>
  )
}

export default AddressDropdown
